import {createSlice} from '@reduxjs/toolkit';

const initialState = null;

const userSlice = createSlice({
    name    : 'user',
    initialState,
    reducers: {
        userLoggedIn : (state, action) => action.payload,
        userLoggedOut: (state, action) => initialState,
    },
});

export const {userLoggedIn, userLoggedOut} = userSlice.actions;

export const selectUser = ({user}) => user;

export default userSlice.reducer;
